<template>
  <div class="row mb-5">
    
    <div class="col text-center" v-if="isNarrowScreen">
      <div class="Blurb pt-0 px-0 pb-3">
        <div class="Blurb-blockquote">
          <h2>{{ withoutWolves ? 'A World without Wolves' : 'A World with Wolves' }}</h2>
          <p>{{ withoutWolves ? 'Yellowstone without wolves 1926 – 1995' : 'Yellowstone with wolves 1995 – present' }}</p>
        </div>
        <h2>Swipe left/right to Explore</h2>
        <p>Tap the Ecosystem to Learn More</p>
      </div>
    </div>
    
    <!-- without wolves -->
    <div class="col-md-6 ImageMap-container" v-show="withoutWolves === null || withoutWolves" :key="'withWolves'">
      <div class="Blurb Blurb-blockquote" v-if="!isNarrowScreen">
        <h2>A World Without Wolves</h2>
        <p>Yellowstone without wolves 1926 – 1995</p>
      </div>
      <svg
        id="ImageMap-without"
        class="ImageMap ImageMap--ie--ecosystem"
        @mouseover="pingHiddenWithout = false" 
        @mouseout="pingHiddenWithout = true"
        version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	      viewBox="0 0 508 1100" style="enable-background:new 0 0 508 1100;" xml:space="preserve">
        <image style="overflow:visible;" width="508" height="1100" xlink:href="./../../../static/images/landscape/landscape-without-wolves.jpg">
        </image>
        <g 
          id="wo-understory" 
          @mouseover="currentDetail = 'wo-understory'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="99.5" y="330" class="ImageMap-detail" width="199.5" height="53.5"/>
        </g>
        <g 
          id="wo-erosion" 
          @mouseover="currentDetail = 'wo-erosion'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="307" y="586" class="ImageMap-detail" width="128" height="73"/>
        </g>
        <g 
          id="wo-water" 
          @mouseover="currentDetail = 'wo-water'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="342" y="682" class="ImageMap-detail" width="128" height="73"/>
        </g>
        <g 
          id="wo-coyote"
          @mouseover="currentDetail = 'wo-coyote'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="307" y="490" class="ImageMap-detail" width="128" height="73"/>
        </g>
        <g 
          id="wo-elk"
          @mouseover="currentDetail = 'wo-elk'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="40" y="667.5" class="ImageMap-detail" width="128" height="73"/>
        </g>
        <g 
          id="wo-aspen"
          @mouseover="currentDetail = 'wo-aspen'" 
          @mouseout="currentDetail = ''"
        >
          <rect y="407" class="ImageMap-detail" width="109.5" height="73"/>
        </g>
      </svg>

      <span 
        class=" Hotspot Hotspot--wo-elk" 
        :class="{ 'ping--continuous': !pingHiddenWithout, 'is-hidden': pingHiddenWithout }">
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-elk"
        v-if="currentDetail === 'wo-elk'" 
        :class="{ 'is-shown': !pingHiddenWithout }"
      >
        <h3 class="Tooltip-title">{{ woDetails[0].name }}</h3>
        <p class="Tooltip-subtitle">{{ woDetails[0].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--wo-aspen" 
        :class="{ 'ping--continuous': !pingHiddenWithout, 'is-hidden': pingHiddenWithout }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-aspen"
        v-if="currentDetail === 'wo-aspen'" 
        :class="{ 'is-shown': !pingHiddenWithout }"
      >
        <h3 class="Tooltip-title">{{ woDetails[1].name }}</h3>
        <p class="Tooltip-subtitle">{{ woDetails[1].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--wo-understory" 
        :class="{ 'ping--continuous': !pingHiddenWithout, 'is-hidden': pingHiddenWithout }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-understory"
        v-if="currentDetail === 'wo-understory'" 
        :class="{ 'is-shown': !pingHiddenWithout }"
      >
        <h3 class="Tooltip-title">{{ woDetails[2].name }}</h3>
        <p class="Tooltip-subtitle">{{ woDetails[2].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--wo-erosion"
        :class="{ 'ping--continuous': !pingHiddenWithout, 'is-hidden': pingHiddenWithout }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-erosion"
        v-if="currentDetail === 'wo-erosion'" 
        :class="{ 'is-shown': !pingHiddenWithout }"
      >
        <h3 class="Tooltip-title">{{ woDetails[3].name }}</h3>
        <p class="Tooltip-subtitle">{{ woDetails[3].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--wo-coyote"
        :class="{ 'ping--continuous': !pingHiddenWithout, 'is-hidden': pingHiddenWithout }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-coyote" 
        v-if="currentDetail === 'wo-coyote'" 
        :class="{ 'is-shown': !pingHiddenWithout }"
      >
        <h3 class="Tooltip-title">{{ woDetails[4].name }}</h3>
        <p class="Tooltip-subtitle">{{ woDetails[4].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--wo-water"
        :class="{ 'ping--continuous': !pingHiddenWithout, 'is-hidden': pingHiddenWithout }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-water" 
        v-if="currentDetail === 'wo-water'" 
        :class="{ 'is-shown': !pingHiddenWithout }"
      >
        <h3 class="Tooltip-title">{{ woDetails[5].name }}</h3>
        <p class="Tooltip-subtitle">{{ woDetails[5].caption }}</p>
      </div>

    </div>

    <!-- with wolves -->
    <div class="col-md-6 ImageMap-container" v-show="withoutWolves === null || !withoutWolves" :key="'withoutWolves'">
      <div class="Blurb Blurb-blockquote" v-if="!isNarrowScreen">
        <h2>A World With Wolves</h2>
        <p>Yellowstone with wolves 1995 – present</p>
      </div>
      <svg
        id="ImageMap-with"
        class="ImageMap ImageMap--ie--ecosystem"
        @mouseover="pingHiddenWith = false" 
        @mouseout="pingHiddenWith = true"
        version="1.1" xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 508 1100" style="enable-background:new 0 0 508 1100;" xml:space="preserve">
        <image style="overflow:visible;" width="508" height="1100" xlink:href="./../../../static/images/landscape/landscape-with-wolves.jpg">
        </image>
        <g 
          id="ww-understory" 
          @mouseover="currentDetail = 'ww-understory'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="118.5" y="337" class="ImageMap-detail" width="199.5" height="53.5"/>
        </g>
        <g 
          id="ww-beavers" 
          @mouseover="currentDetail = 'ww-beavers'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="278.3" y="610" class="ImageMap-detail" width="163.3" height="97.3"/>
        </g>
        <g 
          id="ww-coyote" 
          @mouseover="currentDetail = 'ww-coyote'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="154.8" y="390.5" class="ImageMap-detail" width="163.3" height="60"/>
        </g>
        <g 
          id="ww-waterQuality" 
          @mouseover="currentDetail = 'ww-waterQuality'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="361" y="790" class="ImageMap-detail" width="128" height="52.7"/>
        </g>
        <g 
          id="ww-willows" 
          @mouseover="currentDetail = 'ww-willows'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="135" y="648.7" class="ImageMap-detail" width="143.3" height="83.3"/>
        </g>
        <g 
          id="ww-carrion" 
          @mouseover="currentDetail = 'ww-carrion'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="265.3" y="848.7" class="ImageMap-detail" width="143.3" height="83.3"/>
        </g>
        <g 
          id="ww-elk" 
          @mouseover="currentDetail = 'ww-elk'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="337" y="365" class="ImageMap-detail" width="152" height="73"/>
        </g>
        <g 
          id="ww-nestingBirds" 
          @mouseover="currentDetail = 'ww-nestingBirds'" 
          @mouseout="currentDetail = ''"
        >
          <rect y="546.3" class="ImageMap-detail" width="152" height="73"/>
        </g>
        <g 
          id="ww-aspen" 
          @mouseover="currentDetail = 'ww-aspen'" 
          @mouseout="currentDetail = ''"
        >
          <rect x="19" y="414" class="ImageMap-detail" width="109.5" height="73"/>
        </g>
      </svg>

      <span 
        class=" Hotspot Hotspot--ww-elk" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--ww-elk"
        v-if="currentDetail === 'ww-elk'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[0].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[0].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-aspen" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-aspen"
        v-if="currentDetail === 'ww-aspen'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[1].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[1].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-understory" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--wo-understory"
        v-if="currentDetail === 'ww-understory'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[2].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[2].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-nestingBirds" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--ww-nestingBirds"
        v-if="currentDetail === 'ww-nestingBirds'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[3].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[3].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-coyote" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--ww-coyote"
        v-if="currentDetail === 'ww-coyote'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[4].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[4].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-willows" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--ww-willows"
        v-if="currentDetail === 'ww-willows'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[5].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[5].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-beavers" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--ww-beavers"
        v-if="currentDetail === 'ww-beavers'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[6].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[6].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-carrion" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--ww-carrion"
        v-if="currentDetail === 'ww-carrion'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[7].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[7].caption }}</p>
      </div>

      <span 
        class=" Hotspot Hotspot--ww-waterQuality" 
        :class="{ 'ping--continuous': !pingHiddenWith, 'is-hidden': pingHiddenWith }"
      >
      </span>
      <div 
        class="Tooltip Tooltip--ecosystem Tooltip--ww-waterQuality"
        v-if="currentDetail === 'ww-waterQuality'" 
        :class="{ 'is-shown': !pingHiddenWith }"
      >
        <h3 class="Tooltip-title">{{ wwDetails[8].name }}</h3>
        <p class="Tooltip-subtitle">{{ wwDetails[8].caption }}</p>
      </div>

    </div>
    <!-- </transition-group> -->
  </div>
</template>

<script>
import Hammer from 'hammerjs'
import mixinHelper from './../mixins/helper'

export default {
  name: 'landscapeMap',

  mixins: [ mixinHelper ],

  data () {
    return {
      currentDetail: '',
      pingHiddenWithout: null,
      pingHiddenWith: null,
      withoutWolves: null
    }
  },

  computed: {
    isNarrowScreen () {
      return window.innerWidth < 768
    },

    landscapeContent () {
      return this.$store.getters.landscapeContent
    },

    mapDescription () {
      return this.withoutWolves ? '' : ''
    },

    withoutWolvesMapObj () {
      return this.$store.getters.landscapeContent.maps[0]
    },

    withWolvesMapObj () {
      return this.$store.getters.landscapeContent.maps[1]
    },

    woDetails () {
      return this.$store.getters.landscapeContent.maps[0].mapDetails
    },

    wwDetails () {
      return this.$store.getters.landscapeContent.maps[1].mapDetails
    }
  },

  methods: {
    swipeController (id) {
      const map = document.getElementById(id)
      const mc = new Hammer.Manager(map, {
        touchAction: 'pan-y'
      })
      const swipeX = new Hammer.Swipe()
      mc.add(swipeX)
      mc.on('swipeleft', () => {
        this.withoutWolves = !this.withoutWolves
      })
      mc.on('swiperight', () => {
        this.withoutWolves = !this.withoutWolves
      })
    }
  },

  beforeCreate () {
    this.$store.dispatch('getLocalData', 'landscape')
  },

  mounted () {
    setTimeout(() => {
      if (this.pingHiddenWithout === null) {
        this.pingHiddenWithout = true
      }
      if (this.pingHiddenWith === null) {
        this.pingHiddenWith = true
      }
    }, 1000 * 10)

    if (this.isNarrowScreen) {
      this.withoutWolves = true
      this.swipeController('ImageMap-without')
      this.swipeController('ImageMap-with')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../../assets/_variables.scss';
@import './../../assets/_image-map.scss';

// Without Wolves
.Hotspot--wo-elk {
  top: 62%;
  left: 20%;
  @media screen and (min-width: $grid-md) {
    top: 66%;
  }
}

.Tooltip--wo-elk {
  top: 72%;
}

.Hotspot--wo-aspen {
  top: 39%;
  left: 11%;
  @media screen and (min-width: $grid-md) {
    top: 45%;
  }
}

.Tooltip--wo-aspen {
  top: 50%;
}

.Hotspot--wo-understory {
  top: 31%;
  left: 38%;
  @media screen and (min-width: $grid-md) {
    top: 38%;
  }
}

.Tooltip--wo-understory {
  top: 23%;
}

.Hotspot--wo-erosion {
  top: 55%;
  left: 70%;
  @media screen and (min-width: $grid-md) {
    top: 60%;
  }
}

.Tooltip--wo-erosion {
  top: 66%;
}

.Hotspot--wo-coyote {
  top: 46%;
  left: 70%;
  @media screen and (min-width: $grid-md) {
    top: 52%;
  }
}

.Tooltip--wo-coyote {
  top: 58%;
}

.Hotspot--wo-water {
  top: 63%;
  left: 77%;
  @media screen and (min-width: $grid-md) {
    top: 68%;
  }
}

.Tooltip--wo-water {
  top: 73%;
}

// With Wolves
.Hotspot--ww-elk {
  top: 35%;
  left: 78%;
  @media screen and (min-width: $grid-md) {
    top: 41.5%;
  }
}

.Tooltip--ww-elk {
  top: 46%;
}

.Hotspot--ww-aspen {
  top: 39%;
  left: 15%;
  @media screen and (min-width: $grid-md) {
    top: 45%;
  }
}

.Hotspot--ww-understory {
  top: 31.5%;
  left: 42%;
  @media screen and (min-width: $grid-md) {
    top: 38.5%;
  }
}

.Hotspot--ww-nestingBirds {
  top: 51.5%;
  left: 15%;
  @media screen and (min-width: $grid-md) {
    top: 56.5%;
  }
}

.Tooltip--ww-nestingBirds {
  top: 62%;
}

.Hotspot--ww-coyote {
  top: 37%;
  left: 47%;
  @media screen and (min-width: $grid-md) {
    top: 43%;
  }
}

.Tooltip--ww-coyote {
  top: 48%;
}

.Hotspot--ww-willows {
  top: 61%;
  left: 39%;
  @media screen and (min-width: $grid-md) {
    top: 65%;
  }
}

.Tooltip--ww-willows {
  top: 71%;
}

.Hotspot--ww-beavers {
  top: 58%;
  left: 68%;
  @media screen and (min-width: $grid-md) {
    top: 64%;
  }
}

.Tooltip--ww-beavers {
  top: 68%;
}

.Hotspot--ww-carrion {
  top: 78%;
  left: 64%;
  @media screen and (min-width: $grid-md) {
    top: 81.5%;
  }
}

.Tooltip--ww-carrion {
  top: 88%;
}

.Hotspot--ww-waterQuality {
  top: 72%;
  left: 80%;
  @media screen and (min-width: $grid-md) {
    top: 75.5%;
  }
}

.Tooltip--ww-waterQuality {
  top: 79%;
}

</style>



// WEBPACK FOOTER //
// src/components/landscape/landscape-map.vue